/* EQUESTRINATIONS — Shopify theme behaviour
   Ported from js/main.js + js/shop.js. The cart is Shopify's cart
   (/cart/*.js); prices come from Shopify, never from the browser. */

(function () {
  "use strict";

  var EQ = window.EQ || {};
  var ROUTES = EQ.routes || {};
  var CURRENCY = EQ.currency || "AED";

  /* ---- Formatting --------------------------------------------- */
  function money(cents) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat("en-AE", {
        style: "currency", currency: CURRENCY,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (e) {
      return CURRENCY + " " + amount;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function stripHtml(s) {
    var d = document.createElement("div");
    d.innerHTML = s || "";
    return (d.textContent || "").trim();
  }

  /* ---- Mobile nav --------------------------------------------- */
  var toggle = document.querySelector(".nav__toggle");
  var links = document.querySelector(".nav__links");
  if (toggle && links) {
    toggle.addEventListener("click", function () {
      var open = links.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    links.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        links.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  /* ---- Dropdown menus: tap as well as hover -------------------
     Above the mobile breakpoint the flyout was opened only by :hover /
     :focus-within, which a touch screen cannot drive: the first tap
     revealed it and the next dismissed it instead of following the link.
     Toggle an explicit class on click so taps work at any width. */
  var drops = document.querySelectorAll(".nav__drop");
  if (drops.length) {
    var closeDrops = function (except) {
      drops.forEach(function (d) {
        if (d === except) return;
        d.classList.remove("is-open");
        var t = d.querySelector(".nav__drop-trigger");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    };
    drops.forEach(function (drop) {
      var trigger = drop.querySelector(".nav__drop-trigger");
      if (!trigger) return;
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = drop.classList.contains("is-open");
        closeDrops(null);
        if (!wasOpen) {
          drop.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".nav__drop")) return;
      closeDrops(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.key === "Esc") closeDrops(null);
    });
  }

  /* ---- New-release slideshow ----------------------------------
     Cycles every piece in the 'new' collection through the main tile,
     2s per slide, cross-fading so there is no flash while the next
     image loads. Slide data is rendered by sections/new-release.liquid. */
  (function () {
    var data = document.querySelector("[data-new-slides]");
    var img = document.querySelector("[data-new-img]");
    if (!data || !img) return;

    var slides;
    try { slides = JSON.parse(data.textContent || "[]"); } catch (e) { return; }
    if (!slides || slides.length < 2) return;

    var link = document.querySelector("[data-new-link]");
    var cap = document.querySelector("[data-new-caption]");

    // Preload so a swap never shows an empty frame.
    slides.forEach(function (s) { var i = new Image(); i.src = s.src; });

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    // Start on whichever slide the server rendered.
    var idx = 0;
    for (var i = 0; i < slides.length; i++) {
      if (img.getAttribute("src") === slides[i].src) { idx = i; break; }
    }

    var FADE = 400;
    img.style.transition = "opacity " + FADE + "ms var(--ease), transform 0.5s var(--ease)";
    setInterval(function () {
      idx = (idx + 1) % slides.length;
      var next = slides[idx];
      img.style.opacity = "0";
      setTimeout(function () {
        img.src = next.src;
        img.alt = next.title;
        if (cap) cap.textContent = next.title;
        if (link) link.setAttribute("href", next.url);
        img.style.opacity = "1";
      }, FADE);
    }, 2000);
  })();

  /* ---- Reveal on scroll --------------------------------------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---- Land on the right section for #hash links -------------- */
  function scrollToHash() {
    var id = (location.hash || "").slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    target.scrollIntoView();
    root.style.scrollBehavior = prev;
  }
  if (location.hash) {
    window.addEventListener("load", function () {
      scrollToHash();
      setTimeout(scrollToHash, 250);
    });
  }

  /* ---- Cart badge --------------------------------------------- */
  function setCartCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  function refreshCartCount() {
    return fetch(ROUTES.cart_url + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; })
      .catch(function () { /* leave the server-rendered count */ });
  }

  /* ---- Collection hero slideshow ------------------------------ */
  (function initCollectionHero() {
    var box = document.querySelector("[data-collection-slideshow]");
    if (!box) return;
    var slides = box.querySelectorAll(".hero-slide");
    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var idx = 0;
    setInterval(function () {
      slides[idx].classList.remove("is-active");
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add("is-active");
    }, 3000);
  })();

  /* ---- Quick-view modal --------------------------------------- */
  var modal = document.querySelector("[data-modal]");
  var modalProduct = null;
  var productCache = {};
  var zoomReset = function () {};

  function normalizeOptions(p) {
    // /products/{handle}.js returns either ["Size"] or [{name, values}].
    var opts = p.options || [];
    if (!opts.length) return [];
    if (typeof opts[0] === "string") {
      return opts.map(function (name, i) {
        var seen = {}, values = [];
        (p.variants || []).forEach(function (v) {
          var val = v.options[i];
          if (val && !seen[val]) { seen[val] = 1; values.push(val); }
        });
        return { name: name, values: values };
      });
    }
    return opts.map(function (o) { return { name: o.name, values: o.values }; });
  }

  function hasRealOptions(opts) {
    return !(opts.length === 1 && opts[0].values.length === 1 &&
             opts[0].values[0] === "Default Title");
  }

  function selectedVariant(p) {
    if (!modal) return null;
    var selects = modal.querySelectorAll("[data-modal-option]");
    if (!selects.length) return p.variants[0];
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = null;
    (p.variants || []).forEach(function (v) {
      if (match) return;
      var ok = true;
      chosen.forEach(function (val, i) { if (v.options[i] !== val) ok = false; });
      if (ok) match = v;
    });
    return match;
  }

  function syncModalVariant() {
    if (!modalProduct) return;
    var v = selectedVariant(modalProduct);
    var priceEl = modal.querySelector("[data-modal-price]");
    var addBtn = modal.querySelector("[data-modal-add]");
    if (v) {
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = "Unavailable";
    }
  }

  function renderModalOptions(p) {
    var wrap = modal.querySelector("[data-modal-options]");
    if (!wrap) return;
    wrap.innerHTML = "";
    var opts = normalizeOptions(p);
    if (!hasRealOptions(opts)) return;
    opts.forEach(function (opt, i) {
      var label = document.createElement("label");
      label.className = "pmodal__field";
      var span = document.createElement("span");
      span.textContent = opt.name;
      var sel = document.createElement("select");
      sel.setAttribute("data-modal-option", String(i));
      opt.values.forEach(function (val) {
        var o = document.createElement("option");
        o.value = val; o.textContent = val;
        sel.appendChild(o);
      });
      sel.addEventListener("change", syncModalVariant);
      label.appendChild(span);
      label.appendChild(sel);
      wrap.appendChild(label);
    });
  }

  function openModal(p) {
    if (!modal) return;
    modalProduct = p;
    var img = modal.querySelector("[data-modal-img]");
    if (img) {
      img.src = p.featured_image || (p.images && p.images[0]) || "";
      img.alt = p.title;
      img.classList.remove("is-zoomed");
      img.style.transformOrigin = "";
    }
    zoomReset();
    setText("[data-modal-cat]", p.type || "");
    setText("[data-modal-name]", p.title);
    // Full description HTML, matching the product page. (setText would
    // flatten the headings and lists into one run-on paragraph.)
    var descEl = modal.querySelector("[data-modal-desc]");
    if (descEl) descEl.innerHTML = p.description || "";
    setText("[data-modal-note]", "");
    renderModalOptions(p);
    var qtySel = modal.querySelector("[data-modal-qty]");
    if (qtySel) qtySel.value = "1";
    var full = modal.querySelector("[data-modal-full]");
    if (full) full.setAttribute("href", p.url);
    syncModalVariant();
    modal.hidden = false;
    document.documentElement.classList.add("modal-open");
  }

  function closeModal() {
    if (!modal) return;
    zoomReset();
    modal.hidden = true;
    document.documentElement.classList.remove("modal-open");
    modalProduct = null;
  }

  function setText(sel, text) {
    if (!modal) return;
    var el = modal.querySelector(sel);
    if (el) el.textContent = text;
  }

  function loadProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("not found");
        return r.json();
      })
      .then(function (p) { productCache[handle] = p; return p; });
  }

  if (modal) {
    // quantity 1–10
    var qtySel = modal.querySelector("[data-modal-qty]");
    if (qtySel && !qtySel.options.length) {
      for (var i = 1; i <= 10; i++) {
        var o = document.createElement("option");
        o.value = String(i); o.textContent = String(i);
        qtySel.appendChild(o);
      }
    }

    modal.querySelectorAll("[data-modal-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal();
    });

    /* Click to zoom, move to explore.
       Zooming hands the whole dialog to the photo and scales to roughly
       1:1 with the source pixels, so a customer can sweep the entire
       product at the best detail the photo actually holds. Panning is
       measured against the PHOTO, not the img box — with object-fit:
       contain those differ, and using the box would leave dead zones. */
    var mimg = modal.querySelector("[data-modal-img]");
    var media = modal.querySelector(".pmodal__media");
    var dialog = modal.querySelector(".pmodal__dialog");
    var hint = modal.querySelector(".pmodal__zoomhint");
    var HINT_IDLE = hint ? hint.textContent : "";
    var HINT_ZOOM = "Click to exit \u00b7 move to explore";

    function photoBox() {
      var r = media.getBoundingClientRect();
      var nW = mimg.naturalWidth, nH = mimg.naturalHeight;
      if (!nW || !nH) return { left: r.left, top: r.top, width: r.width, height: r.height, elem: r, fit: 0 };
      var fit = Math.min(r.width / nW, r.height / nH);
      return {
        left: r.left + (r.width - nW * fit) / 2,
        top: r.top + (r.height - nH * fit) / 2,
        width: nW * fit, height: nH * fit, elem: r, fit: fit
      };
    }
    function clamp01(v) { return Math.min(Math.max(v, 0), 1); }
    function fractionAt(clientX, clientY) {
      var b = photoBox();
      return [clamp01((clientX - b.left) / b.width), clamp01((clientY - b.top) / b.height)];
    }
    function applyFraction(fx, fy) {
      var b = photoBox(), r = b.elem;
      var ox = ((b.left - r.left) + fx * b.width) / r.width * 100;
      var oy = ((b.top - r.top) + fy * b.height) / r.height * 100;
      mimg.style.transformOrigin = ox + "% " + oy + "%";
    }
    function applyZoomScale() {
      var b = photoBox();
      // 1/fit renders one image pixel per CSS pixel; clamp so small photos
      // don't blur and very large ones stay usable.
      var native = b.fit ? 1 / b.fit : 2.6;
      mimg.style.setProperty("--zoom", Math.max(2, Math.min(native, 4)).toFixed(3));
    }
    function enterZoom(clientX, clientY) {
      var f = fractionAt(clientX, clientY);   // measure before the panel resizes
      if (dialog) dialog.classList.add("is-zooming");
      mimg.classList.add("is-zoomed");
      if (dialog) void dialog.offsetWidth;    // settle the new layout
      applyZoomScale();
      applyFraction(f[0], f[1]);
      if (hint) hint.textContent = HINT_ZOOM;
    }
    function exitZoom() {
      if (dialog) dialog.classList.remove("is-zooming");
      if (mimg) {
        mimg.classList.remove("is-zoomed");
        mimg.style.transformOrigin = "";
        mimg.style.removeProperty("--zoom");
      }
      if (hint && HINT_IDLE) hint.textContent = HINT_IDLE;
    }
    zoomReset = exitZoom;

    if (mimg) {
      mimg.addEventListener("click", function (e) {
        if (mimg.classList.contains("is-zoomed")) exitZoom();
        else enterZoom(e.clientX, e.clientY);
      });
    }
    if (media) {
      media.addEventListener("mousemove", function (e) {
        if (mimg && mimg.classList.contains("is-zoomed")) {
          var f = fractionAt(e.clientX, e.clientY);
          applyFraction(f[0], f[1]);
        }
      });
      media.addEventListener("touchmove", function (e) {
        if (mimg && mimg.classList.contains("is-zoomed") && e.touches[0]) {
          var f = fractionAt(e.touches[0].clientX, e.touches[0].clientY);
          applyFraction(f[0], f[1]);
          e.preventDefault();
        }
      }, { passive: false });
    }
    window.addEventListener("resize", function () {
      if (mimg && mimg.classList.contains("is-zoomed")) applyZoomScale();
    });

    var addBtn = modal.querySelector("[data-modal-add]");
    if (addBtn) addBtn.addEventListener("click", function () {
      if (!modalProduct) return;
      var v = selectedVariant(modalProduct);
      if (!v) return;
      var qty = parseInt((modal.querySelector("[data-modal-qty]") || {}).value || "1", 10);
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";
      fetch(ROUTES.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || "Could not add"); return d; }); })
        .then(function () {
          setText("[data-modal-note]", "Added " + qty + " × " + modalProduct.title +
            (v.title && v.title !== "Default Title" ? " — " + v.title : "") + ".");
          addBtn.textContent = "Added ✓";
          return refreshCartCount();
        })
        .catch(function (err) {
          setText("[data-modal-note]", err.message);
          addBtn.textContent = "Add to cart";
        })
        .finally(function () {
          setTimeout(function () {
            addBtn.disabled = false;
            syncModalVariant();
          }, 1300);
        });
    });
  }

  // Open quick view from any product card
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-open]");
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute("data-open");
    loadProduct(handle).then(openModal).catch(function () {
      window.location.href = "/products/" + handle;
    });
  });

  /* ---- Search modal (predictive search) ----------------------- */
  (function initSearch() {
    var wrap = document.querySelector("[data-search]");
    if (!wrap) return;
    var input = wrap.querySelector("[data-search-input]");
    var results = wrap.querySelector("[data-search-results]");
    var form = wrap.querySelector("[data-search-form]");
    var timer = null;

    function open() {
      wrap.hidden = false;
      document.documentElement.classList.add("modal-open");
      setTimeout(function () { input.focus(); }, 30);
    }
    function close() {
      wrap.hidden = true;
      document.documentElement.classList.remove("modal-open");
      input.value = "";
      draw([]);
    }

    function hint(msg) {
      results.innerHTML = '<p class="search-modal__hint muted">' + msg + "</p>";
    }

    function draw(items, q, total) {
      if (!q) { hint("Start typing to search the shop…"); return; }
      if (!items.length) { hint("No matches for “" + escapeHtml(q) + "”."); return; }
      var html = items.map(function (p) {
        return '<a class="search-result" href="' + p.url + '">' +
          '<img class="search-result__img" src="' + (p.featured_image && p.featured_image.url ? p.featured_image.url : "") + '" alt="" loading="lazy" />' +
          '<span class="search-result__name">' + escapeHtml(p.title) + "</span>" +
          '<span class="search-result__price">' + (p.price ? money(p.price) : "") + "</span>" +
          "</a>";
      }).join("");
      if (total && total > items.length) {
        html += '<a class="search-result search-result--all" href="' + ROUTES.search_url +
          "?q=" + encodeURIComponent(q) + '">See all results →</a>';
      }
      results.innerHTML = html;
    }

    function query() {
      var q = input.value.trim();
      if (!q) { draw([], ""); return; }
      fetch(ROUTES.predictive_search_url + "?q=" + encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=8", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          // Table bookings are market stock, not shop stock — keep them out of shop search.
          products = products.filter(function (p) { return (p.title || "").indexOf("Table booking") !== 0; });
          // Shopify's predictive search is relevance-ranked and typo-tolerant, so
          // it returns near-misses too ("black" bringing back Blue Disco). Keep
          // only products whose title actually contains every word typed.
          var terms = q.toLowerCase().split(/\s+/).filter(Boolean);
          products = products.filter(function (p) {
            var t = (p.title || "").toLowerCase();
            return terms.every(function (w) { return t.indexOf(w) > -1; });
          });
          draw(products, q, products.length === 8 ? 99 : products.length);
        })
        .catch(function () { hint("Search is unavailable right now."); });
    }

    document.querySelectorAll("[data-search-open]").forEach(function (b) {
      b.addEventListener("click", open);
    });
    wrap.querySelectorAll("[data-search-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !wrap.hidden) close();
    });
    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(query, 200);
    });
    form.addEventListener("submit", function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
    draw([], "");
  })();

  /* ---- Cart page ---------------------------------------------- */
  function bindCart() {
    var wrap = document.querySelector("[data-cart-section]");
    if (!wrap) return;
    var sectionId = wrap.getAttribute("data-cart-section");

    function change(line, quantity) {
      wrap.classList.add("is-busy");
      fetch(ROUTES.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCartCount(cart.item_count);
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var fresh = doc.querySelector("[data-cart-section]");
            if (fresh) {
              wrap.innerHTML = fresh.innerHTML;
              return;
            }
          }
          window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    }

    wrap.addEventListener("click", function (e) {
      var inc = e.target.closest("[data-inc]");
      var dec = e.target.closest("[data-dec]");
      var rem = e.target.closest("[data-remove]");
      var clr = e.target.closest("[data-cart-clear]");
      if (inc) { change(+inc.getAttribute("data-line"), +inc.getAttribute("data-inc")); }
      if (dec) { change(+dec.getAttribute("data-line"), +dec.getAttribute("data-dec")); }
      if (rem) { change(+rem.getAttribute("data-line"), 0); }
      if (clr) {
        if (window.confirm("Remove all items from your cart?")) {
          fetch(ROUTES.cart_url + "/clear.js", { method: "POST", headers: { Accept: "application/json" } })
            .then(function () { window.location.reload(); });
        }
      }
    });
  }
  bindCart();

  /* ---- Discount code carried into Shopify checkout ------------ */
  (function initPromo() {
    var promo = document.querySelector("[data-cart-promo]");
    var hidden = document.querySelector("[data-cart-discount]");
    if (!promo || !hidden) return;
    function sync() { hidden.value = promo.value.trim(); }
    promo.addEventListener("input", sync);
    sync();
  })();

  /* ---- Product page: thumbs, zoom, variant price -------------- */
  (function initPdp() {
    var main = document.querySelector("[data-pdp-main]");
    if (!main) return;

    var fig = main.closest(".pdp__figure");
    var thumbs = document.querySelectorAll("[data-pdp-thumb], [data-pdp-video]");
    var panels = document.querySelectorAll("[data-pdp-video-panel]");

    // Photo thumbs swap the main image; video thumbs swap in their player.
    function showVideo(id) {
      if (fig) fig.classList.toggle("is-video", !!id);
      panels.forEach(function (p) {
        var on = p.getAttribute("data-pdp-video-panel") === id;
        var v = p.querySelector("video");
        p.hidden = !on;
        if (!v) return;
        if (on) { var play = v.play(); if (play && play.catch) play.catch(function () {}); }
        else v.pause();
      });
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var vid = btn.getAttribute("data-pdp-video");
        if (vid) {
          showVideo(vid);
        } else {
          showVideo(null);
          main.src = btn.getAttribute("data-pdp-thumb");
        }
        main.classList.remove("is-zoomed");
        main.style.transformOrigin = "";
        thumbs.forEach(function (b) { b.classList.toggle("is-active", b === btn); });
      });
    });

    function panFrom(clientX, clientY) {
      if (!fig) return;
      var r = fig.getBoundingClientRect();
      var x = Math.min(Math.max((clientX - r.left) / r.width, 0), 1) * 100;
      var y = Math.min(Math.max((clientY - r.top) / r.height, 0), 1) * 100;
      main.style.transformOrigin = x + "% " + y + "%";
    }
    main.addEventListener("click", function (e) {
      var zoomed = main.classList.toggle("is-zoomed");
      if (zoomed) panFrom(e.clientX, e.clientY);
      else main.style.transformOrigin = "";
    });
    if (fig) {
      fig.addEventListener("mousemove", function (e) {
        if (main.classList.contains("is-zoomed")) panFrom(e.clientX, e.clientY);
      });
      fig.addEventListener("touchmove", function (e) {
        if (main.classList.contains("is-zoomed") && e.touches[0]) {
          panFrom(e.touches[0].clientX, e.touches[0].clientY);
          e.preventDefault();
        }
      }, { passive: false });
    }

    // Keep the price and the ?variant= URL in step with the picker.
    var picker = document.querySelector("[data-pdp-variants]");
    var priceEl = document.querySelector("[data-pdp-price]");
    if (picker) {
      picker.addEventListener("change", function () {
        var opt = picker.options[picker.selectedIndex];
        if (priceEl && opt) priceEl.textContent = opt.getAttribute("data-price") || priceEl.textContent;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", picker.value);
          window.history.replaceState({}, "", url);
        } catch (e) { /* older browser — the form still posts the right id */ }
      });
    }
  })();

  /* ---- Table booking (market: Vendors page) -------------------
     Ported from js/booking.js. The picker holds Shopify variant ids, so
     checkout goes through Shopify's cart — the old Netlify Stripe call is
     gone. Prices come from the rendered options, which Liquid fills from
     the real products, and Shopify charges its own price at checkout. */
  (function initBooking() {
    var wrap = document.querySelector("[data-booking]");
    if (!wrap) return;

    var select = wrap.querySelector("[data-book-select]");
    var addBtn = wrap.querySelector("[data-book-add-select]");
    if (!select || !addBtn) return;

    var emptyMsg = wrap.querySelector("[data-booking-empty]");
    var listEl = wrap.querySelector("[data-booking-list]");
    var summaryEl = wrap.querySelector("[data-booking-summary]");
    var totalEl = wrap.querySelector("[data-book-total]");
    var btn = wrap.querySelector("[data-book-checkout]");
    var note = wrap.querySelector("[data-book-note]");

    var chosen = {};   // variantId -> { name, price (cents), qty }

    function optionFor(id) { return select.querySelector('option[value="' + id + '"]'); }

    function add(id) {
      if (!id) return;
      if (chosen[id]) { chosen[id].qty += 1; render(); return; }
      var opt = optionFor(id);
      if (!opt) return;
      chosen[id] = {
        name: opt.textContent,
        price: parseInt(opt.getAttribute("data-price"), 10) || 0,
        qty: 1
      };
      render();
    }

    function remove(id) {
      if (!chosen[id]) return;
      chosen[id].qty -= 1;
      if (chosen[id].qty <= 0) delete chosen[id];
      render();
    }

    function render() {
      var ids = Object.keys(chosen);
      if (note) note.textContent = "";

      if (!ids.length) {
        if (emptyMsg) emptyMsg.hidden = false;
        if (listEl) { listEl.hidden = true; listEl.innerHTML = ""; }
        if (summaryEl) summaryEl.hidden = true;
        if (btn) btn.disabled = true;
        return;
      }
      if (emptyMsg) emptyMsg.hidden = true;
      if (summaryEl) summaryEl.hidden = false;
      if (btn) btn.disabled = false;

      var total = 0;
      listEl.innerHTML = "";
      ids.forEach(function (id) {
        var it = chosen[id];
        total += it.price * it.qty;
        var qtyLabel = it.qty > 1 ? ' <span class="booking__item-qty">×&nbsp;' + it.qty + "</span>" : "";
        var li = document.createElement("li");
        li.className = "booking__item";
        li.innerHTML =
          '<span class="booking__item-name">' + escapeHtml(it.name) + qtyLabel + "</span>" +
          '<button type="button" class="booking__item-remove" data-book-remove="' + id + '" aria-label="Remove one">Remove</button>';
        listEl.appendChild(li);
      });
      listEl.hidden = false;
      if (totalEl) totalEl.textContent = money(total);
    }

    addBtn.addEventListener("click", function () {
      add(select.value);
      select.selectedIndex = 0;
    });

    listEl.addEventListener("click", function (e) {
      var r = e.target.closest("[data-book-remove]");
      if (r) remove(r.getAttribute("data-book-remove"));
    });

    /* Tile "Add" buttons sit in the #tables section, outside [data-booking],
       so the listener goes on the document. They feed the same add() as the
       picker, so name and price still come from the rendered <option>. */
    function flashAdded(el) {
      if (el.getAttribute("data-flashing")) return;
      var label = el.textContent;
      el.setAttribute("data-flashing", "1");
      el.classList.add("is-added");
      el.textContent = "Added";
      setTimeout(function () {
        el.textContent = label;
        el.classList.remove("is-added");
        el.removeAttribute("data-flashing");
      }, 1200);
    }

    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-book-add-card]");
      if (!t) return;
      var id = t.getAttribute("data-book-add-card");
      if (!optionFor(id)) return;
      add(id);
      flashAdded(t);

      /* The booking sits further down the page, so take the vendor to it —
         otherwise the tile click looks like it did nothing. Honours the
         #reserve scroll-margin used by the "Reserve your table" anchor. */
      var target = document.getElementById("reserve") || wrap;
      if (target && target.scrollIntoView) {
        var reduced = window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
      }
    });

    btn.addEventListener("click", function () {
      var items = Object.keys(chosen).map(function (id) {
        return { id: parseInt(id, 10), quantity: chosen[id].qty };
      });
      if (!items.length) return;

      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = "Redirecting to secure checkout…";

      fetch(ROUTES.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || "Could not reserve that table");
            return d;
          });
        })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = label;
          if (note) note.textContent = err.message + " — or email info@equestrinations.com and we'll help.";
        });
    });

    render();
  })();

  refreshCartCount();
})();
